import React from 'react'
import PropTypes from 'prop-types'

const VendorIcon = ({ style, width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <g fill="none" fillRule="evenodd">
      <path stroke="#FFF" strokeWidth="2" d="M15 8.218l-10 .47V15h10V8.218z" />
      <path
        stroke="#FFF"
        strokeWidth="2"
        d="M8.111 4L7.52 5.923v1.332a.98.98 0 0 1-1.963 0v-.906L6.963 4h1.148zm2.167 0l.666 2.24v1.038a.981.981 0 1 1-1.963 0V6.24L9.648 4h.63zm2.963 0l1.166 2.315v.981a.981.981 0 1 1-1.963 0V5.963L11.814 4h1.427zM17 6.333V7a.556.556 0 0 1-1.111 0V5.908l-.037-.075-.908-1.814h.723L17 6.333zM4.593 4h.61L4.149 5.76v.036l-.037.093v1.13a.556.556 0 0 1-1.111 0V6.37L4.593 4z"
      />
      <path fill="#FFF" d="M5 11h10v2H5z" />
    </g>
  </svg>
)

VendorIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default VendorIcon
